import completed from "assets/images/completed.png";
import inprogress from "assets/images/in-progress.png";
import pending from "assets/images/pending.png";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Card, CardBody, CardHeader, CardImg, CardText, CardTitle
} from "reactstrap";
import { API_URL } from "../Constants"; // Import API_URL
import ReactGA from 'react-ga';
import teamIcon from 'assets/images/teamIcon.png';


class UpcomingTable extends Component {
  constructor() {
    super();
    this.state = {
      data: [],
    };
    ReactGA.event({
      category: 'Upcoming Games',
      action: 'Open'
    });
  }

  componentDidMount() {
    fetch(`${API_URL}/app/api/v1/schedules`)
      .then((results) => {
        return results.json();
      })
      .then((resp) => {
        this.setState({
          data: resp.filter(s => s.status === 'P'),
        });
      });
  }

  render() {
    return (
      <div className="card">
        <div className="header px-4">
          <h4 className="title">Upcoming Games</h4> 
          <p className="category">Captains for following teams, please report to your assigned court ASAP</p>
        </div>
        
        {this.state.data.map((item) => (
          <Card className="m-2 px-3 py-2">
            <CardHeader tag="h6">
              <CardImg width={30} className="me-2" src={teamIcon} alt="Card image cap" /> {item.homeTeamName} vs. {item.visitorTeamName} 
            </CardHeader>
            <CardBody>
              <CardText>Court: {item.courtNo}</CardText>
              <CardText>Round: {item.round}</CardText>
              <CardText>Time: {item.scheduleDate}</CardText>
            </CardBody>
          </Card>
        ))}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.Auth.user,
});

export default connect(mapStateToProps)(UpcomingTable);


// WEBPACK FOOTER //
// ./src/components/Table/UpcomingTable.js